import type { IVueI18n } from 'vue-i18n';
import { getTypesenseIndexName } from '~~/i18n/typesenseLocalization';
import localizationDefinitions from '~~/i18n/localizationDefinitions';
import { getDomainByCountry } from '~~/helpers/domains';

export const i18nToTypesenseMainIndex = (i18n: IVueI18n): string => {

  return getTypesenseIndexName(i18n.localeProperties.value.code, localizationDefinitions) ?? '';

};

export const i18nToCurrentCountryCode = (i18n: IVueI18n): string => {

  return i18n.localeProperties.value.country;

};

export const i18nToCurrentDomain = (i18n: IVueI18n): Maybe<string> => {

  return getDomainByCountry(i18n.localeProperties.value.country);

};

export const i18nToLanguageAndCountry = (i18n: IVueI18n): string => {

  return i18n.localeProperties.value.code;

};
